import { createDiv, createDom, makeClickable, removeDom } from "../domUtils.mjs";
import mockConfig from "./config.mjs";
import createError from "./createError.mjs";
const create = function() {
  return new Promise(function(resolve, reject) {
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv("devkit-instant-mock-squad-create", overlay);
    const box = createDiv("devkit-instant-mock-squad-create-box", container);
    createDom("h1", null, box).innerText = "Create a squad?";
    const divButtons = createDiv(
      "devkit-instant-mock-squad-create-buttons",
      box
    );
    const cancel = createDiv(
      "devkit-instant-mock-squad-create-button-cancel",
      divButtons
    );
    cancel.innerText = "Cancel";
    const create2 = createDiv(
      "devkit-instant-mock-squad-create-button-confirm",
      divButtons
    );
    create2.innerText = "Create";
    makeClickable(create2, () => {
      removeDom(overlay);
      resolve();
    });
    makeClickable(cancel, () => {
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
  });
};
const join = function(id, currentPlayerPhoto) {
  return new Promise(function(resolve, reject) {
    const item = mockConfig.squad[id];
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv("devkit-instant-mock-squad-join", overlay);
    const box = createDiv("devkit-instant-mock-squad-join-box", container);
    const icons = createDiv(null, box);
    createDiv(
      "devkit-instant-mock-squad-join-icon",
      icons
    ).style.backgroundImage = "url(" + currentPlayerPhoto + ")";
    for (const playerId of (item == null ? void 0 : item.players) || []) {
      createDiv(
        "devkit-instant-mock-squad-join-icon",
        icons
      ).style.backgroundImage = "url(" + mockConfig.player[playerId].photo + ")";
    }
    createDom("h1", null, box).innerText = `Join ${(item == null ? void 0 : item.name) || "this squad"}?`;
    const divButtons = createDiv(
      "devkit-instant-mock-squad-create-buttons",
      box
    );
    const cancel = createDiv(
      "devkit-instant-mock-squad-join-button-cancel",
      divButtons
    );
    cancel.innerText = "Cancel";
    const join2 = createDiv(
      "devkit-instant-mock-squad-join-button-confirm",
      divButtons
    );
    join2.innerText = "Join";
    makeClickable(join2, () => {
      removeDom(overlay);
      resolve();
    });
    makeClickable(cancel, () => {
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
  });
};
const squads = { create, join };
export {
  squads as default
};
